/* eslint-disable import/prefer-default-export */
import irelandApi from '../irelandApi';

export const getBrandsUser = () => (dispatch) => {
  dispatch({ type: 'GET_BRANDS_USER_PENDING', payload: [] });

  return irelandApi
    .get('/api/brands')
    .then((response) => {
      const payload = response.data ? response.data : { data: false };
      dispatch({ type: 'GET_BRANDS_USER_FULFILLED', payLoad: payload });
    })
    .catch((error) => {
      dispatch({ type: 'GET_BRANDS_USER_REJECTED', payLoad: error });
    });
};



// WEBPACK FOOTER //
// ./src/actions/brands-user.js